import React,{ useState,useEffect } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import { unescapeHtml } from "../../components/common/Common";

//약관보기
const Terms = () => {
  const { items } = useParams();
  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  const [varConditionTitle,setConditionTitle] = useState('');
  const [varConditionComment,setConditionComment] = useState('');

  //약관호출
  const GetConditionInformation = async(sfield) => {
    const sendData = {sfield:sfield};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_conditions`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setConditionComment(unescapeHtml(datas.comments));
      } else {
        alert(datas.message);
      }
    });
  }

  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  useEffect(() => {
    let stitle = "";
    let sfield = "";
    switch (Number(items)) {
      default:
      case 1:
        stitle = "이용약관 동의";
        sfield = "env_condition";
        break;
      case 2:
        stitle = "개인정보 처리방침 동의";
        sfield = "env_privacy";
        break;
      case 3:
        stitle = "환불 취소 정책 동의";
        sfield = "env_refund";
        break;
      case 4:
        stitle = "마케팅 목적의 개인정보 수집 및 이용동의";
        sfield = "env_marketing";
        break;
    }
    setConditionTitle(stitle)
    GetConditionInformation(sfield);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  return (
    <div className="vh-content normal-wrap st02">
      <HeaderUserTitle varPageTitle={varConditionTitle} varBackString={'/Parents/MyPage'}/>
      <div className="vh-content-body mt25">
        <div className="center-wrap" style={{whiteSpace:"pre-line"}}>{unescapeHtml(varConditionComment)}</div>
      </div>
    </div>
  )
}
export  default Terms;